import {LOGIN_PATH} from "../../routes";

export class LogoutFeature {
    constructor(application) {
        this._application = application;
    }

    async load() {
        await this._application.session().logOut()
        this._returnToLogin()
    }

    _returnToLogin() {
        // Full reload instead of navigating: this screen is the escape hatch for a broken
        // session, and rebuilding the app from scratch is the only way to guarantee no
        // stale state survives in memory.
        window.location.replace(LOGIN_PATH)
    }
}
